import { observer } from 'mobx-react';
import * as React from 'react';
import { Card, TextInput, Grid, RadioSwitch, FormCell } from 'ui-toolkit';
import { Judgement } from './Judgement';
import { IJudgementInformationData } from '../../../ui-toolkit/orders/interfaces/titleReport/IJudgement';

// tslint:disable:jsx-no-lambda TODO: remove this tslint disable

interface IProps {
  data: IJudgementInformationData;
  error?: any;
  title?: string;
  onFormChange: (dataPath: string, newData: any, error?: string | null | undefined) => void;
  onAddNewItem: (dataPath: string) => void;
  onDeleteItem: (dataPath: string, index?: number) => void;
  validateFormData: (path: string) => void;
}

export enum EJudgementResultValues {
  clear = 'clear',
  found = 'found',
}

export const JudgementInformation = observer(class JudgementInformation extends React.Component<IProps, {}> {
  public static defaultProps: Partial<IProps> = {
    title: 'Judgement/Lien Information',
  };

  public render() {
    return (
      <Card title={this.props.title}>
        <Grid>
          <Grid columnCount={2}>
            <TextInput
              value={this.props.data.namesRun}
              label="Names Run"
              placeholder="Ex. Beyonce N Knowles, Beyonce Nancy Knowles"
              onChange={(value) => this.props.onFormChange('judgementInformation.namesRun', value)}
            />
            <FormCell label={'Result'}>
              <RadioSwitch
                name={'result-judgement'}
                onChange={(event) => this.onSwitchJudgement(event)}
                value={this.props.data.clear ? EJudgementResultValues.clear : EJudgementResultValues.found}
                options={[
                  { label: 'Clear', value: EJudgementResultValues.clear },
                  { label: 'Found', value: EJudgementResultValues.found },
                ]}
              />
            </FormCell>
          </Grid>
          {this.props.data.judgements && this.props.data.judgements.length ? (
            <Judgement
              data={this.props.data.judgements}
              error={this.props.error}
              dataPath="judgementInformation.judgements"
              onFormChange={this.props.onFormChange}
              onAddNewItem={this.props.onAddNewItem}
              onDeleteItem={this.props.onDeleteItem}
              validateFormData={this.props.validateFormData}
            />
          ) : null}
        </Grid>
      </Card>
    );
  }

  private onSwitchJudgement(event: React.ChangeEvent<HTMLInputElement>) {
    const isClear = event.target.value === EJudgementResultValues.clear;
    this.props.onFormChange('judgementInformation.clear', isClear);
    if (isClear) {
      this.props.onDeleteItem('judgementInformation.judgements');
    } else {
      this.props.onAddNewItem('judgementInformation.judgements');
    }
  }
});
